export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
     
    {
      title: true,
      name: 'Main-Navigation',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    //main-navigation

    //product
    {
      name: 'Product',
      url: '/product',
      icon: 'fa fa-cart-arrow-down',
      children: [
        {
          name: 'Addproduct',
          url: '/product/Addproduct',
          icon: 'fa fa-circle-thin'
        },
         {
          name: 'Listproduct',
          url: '/product/Listproduct',
          icon: 'fa fa-circle-thin'
        }
      ]
    },
       //purches
    {
      name: 'Purchase',
      url: '/purches',
      icon: 'fa fa-shopping-bag',
      children: [
        {
          name: 'AddPurchase',
          url: '/purches/Addpurches',
          icon: 'fa fa-circle-thin'
        },
         {
          name: 'ListPurchase',
          url: '/purches/Listpurches',
          icon: 'fa fa-circle-thin'
        },
         {
          name: 'AddPurchaseReturn',
          url: '/purches/Addpurchesreturn',
          icon: 'fa fa-circle-thin'
        },
         {
          name: 'ListPurchaseReturn',
          url: '/purches/Listpurchesreturn',
          icon: 'fa fa-circle-thin' 
        }
      ]
    },


    //Transfer
     {
      name: 'Transfer',
      url: '/transfer',
      icon: 'icon-calculator',
      children: [
        {
          name: 'AddTransfer',
          url: '/transfer/Addtransfer',
          icon: 'fa fa-circle-thin'
        },
         {
          name: 'ListTransfer',
          url: '/transfer/Listtransfer',
          icon: 'fa fa-circle-thin'
        }
      ]
    },
     //sales
    {
      name: 'Sales',
      url: '/sales',
      icon: 'icon-pie-chart',
      children: [
      {
          name: 'Saleslist',
          url: '/sales/Sale',
          icon: 'fa fa-shopping-cart',
          children:[
                    {
                     name: 'SalesAdd',
                     url: '/sales/Sale/add',
                     icon: 'fa fa-circle-thin',
                    },
                    {
                     name: 'SalesList',
                     url: '/sales/Sale/list',
                     icon: 'fa fa-circle-thin',
                    }
          ]
        },
        {
          name: 'SalesReturn',
          url: '/sales/Salesreturn',
          icon: 'fa fa-cart-arrow-down',
          children:[
                    {
                     name: 'SalesReturnAdd',
                     url: '/sales/Salesreturn/add',
                     icon: 'fa fa-circle-thin',
                    },
                    {
                     name: 'SalesReturnList',
                     url: '/sales/Salesreturn/list',
                     icon: 'fa fa-circle-thin',
                    }
          ]
        },
        {
          name: 'Quotation',
          url: '/sales',
          icon: 'fa fa-list-alt',
          children:[
                    {
                     name: 'Add',
                     url: '/sales/Quotation/addquotation',
                     icon: 'fa fa-circle-thin',
                    },
                    {
                     name: 'List',
                     url: '/sales/Quotation/listQuotation',
                     icon: 'fa fa-circle-thin',
                    }
          ]
        },
        // {
        //   name: 'Payment',
        //   url: '/sales/Payment',
        //   icon: 'fa fa-credit-card',
        // },
        // {
        //   name: 'Invoice',
        //   url: '/sales/Invoice',
        //   icon: 'fa fa-copy',
        // }

        
      ]
    },

     {
      name: 'Setting',
      url: '/Setting',
      icon: 'icon-star',
      children: [
        {
          name: 'Supplier',
          url: '/Setting/supplier',
          icon: 'icon-star',
          children:[  
             {
                   url: '/Setting/supplier/add',
                   name: 'SupplierAdd',
                     icon: 'icon-star'
                  },
                 {
                   url: '/Setting/supplier/list',
                   name: 'SupplierList',
                     icon: 'icon-star'
                 },
                 ]
        },

        {
          name: 'Customer',
          url: '/Setting/customer',
          icon: 'icon-star',
            children:[
             {
                   url: '/Setting/customer/add',
                   name: 'CustomerAdd',
                     icon: 'icon-star'
                  },
                 {
                   url: '/Setting/customer/list',
                   name: 'CustomerList',
                     icon: 'icon-star'
                 },
                 ]
        },
        {
          name: 'User',
          url: '/Setting/user',
          icon: 'icon-star',
            children:[
             {
                   url: '/Setting/user/add',
                   name: 'UserAdd',
                     icon: 'icon-star'
                  },
                 {
                   url: '/Setting/user/list',
                   name: 'UserList',
                     icon: 'icon-star'
                 },
                 ]
        },
        {
          name: 'Shop',
          url: '/Setting/shop',
          icon: 'icon-star',
            children:[
             {
                   url: '/Setting/shop/add',
                   name: 'ShopAdd',
                     icon: 'icon-star'
                  },
                 {
                   url: '/Setting/shop/list',
                   name: 'ShopList',
                     icon: 'icon-star'
                 },
                 ]
        },
        {
          name: 'Tax',
          url: '/Setting/tax',
          icon: 'icon-star',
        },
        {
          name: 'Category',
          url: '/Setting/category',
          icon: 'icon-star'
        },
        
         {
          name: 'Brand',
          url: '/Setting/brand',
          icon: 'icon-star',
            children:[
             {
                   url: '/Setting/brand/add',
                   name: 'BrandAdd',
                     icon: 'icon-star'
                  },
                
                 ]
        },
         {
          name: 'Role',
          url: '/Setting/Role',
          icon: 'icon-star',
            children:[
             {
                   url: '/Setting/Role/add',
                   name: 'RoleAdd',
                     icon: 'icon-star'
                  },
                
                 ]
        },
  
       ]
    }

    //end-navigation
   
   
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js